// // src/AppLayout.js
// import React from "react";
// import { Outlet } from "react-router-dom";
// import AppToolbar from "./components/AppToolbar";

// const AppLayout = () => {
//   return (
//     <div>
//       <AppToolbar />
//       <div style={{ padding: "20px" }}>
//         <Outlet />
//       </div>
//     </div>
//   );
// };

// export default AppLayout;

// import React from "react";
// import { AppBar, Toolbar, Typography, Box, Container } from "@mui/material";
// import { Outlet } from "react-router-dom";
// import AppToolbar from "./components/AppToolbar";
// import Slider from "./components/Slider";
// import { useLocation } from "react-router-dom";
// import Footer from "./components/Footer";

// const AppLayout = () => {

//   const location = useLocation();
//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//       {/* AppBar */}
//       <AppToolbar />
//       {location.pathname === "/" && <Slider />}
   
//       {/* Main Content */}
//       <Container sx={{ flex: 1, marginTop: 2 }}>
//         <Outlet /> {/* This renders the content of the active route */}
//       </Container>

//       {/* Footer */}
//       <Footer />
//       {/* <Box component="footer" sx={{ backgroundColor: "#f5f5f5", padding: 2, marginTop: 2 }}>
//         <Typography variant="body2" align="center" color="text.secondary">
//           © {new Date().getFullYear()} Freshsweeper Cleaning Service, Inc. All rights reserved.
//         </Typography>
//       </Box> */}
//     </Box>
//   );
// };

// export default AppLayout;



import React, { useState, useEffect } from "react";
import { 
  Box, 
  Container, 
  useTheme, 
  alpha,
  Fade,
  Fab,
  Zoom,
  useScrollTrigger,
} from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AppToolbar from "./components/AppToolbar";
import Slider from "./components/Slider";
import Footer from "./components/Footer";

// Scroll to top button component
const ScrollToTop = () => {
  const theme = useTheme();
  const trigger = useScrollTrigger({
    threshold: 300,
    disableHysteresis: true,
  });

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Zoom in={trigger}>
      <Fab
        onClick={handleClick}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
          backgroundColor: theme.palette.primary.main,
          color: 'white',
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            transform: 'scale(1.1)',
          },
          transition: 'transform 0.2s',
        }}
        size="medium"
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  );
};

// Animated wrapper for page transitions
const PageTransition = ({ children }) => {
  const location = useLocation();
  
  return (
    <Fade in timeout={400} key={location.pathname}>
      <Box>{children}</Box>
    </Fade>
  );
};

const AppLayout = () => {
  const location = useLocation();
  const theme = useTheme();
  const [isScrolled, setIsScrolled] = useState(false);

  // Detect scroll for header styling
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Check if we're on a page that should show the slider
  const showSlider = location.pathname === "/";
  
  // Check if we're on a support page (to remove container padding)
  const isSupportPage = location.pathname.includes('/help') || 
                        location.pathname.includes('/faqs') ||
                        location.pathname.includes('/cleaner-support');

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
        position: 'relative',
      }}
    >
      {/* Gradient Background Effect */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: '100vh',
          background: `radial-gradient(circle at 0% 0%, ${alpha(theme.palette.primary.main, 0.03)} 0%, transparent 50%)`,
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />
      
      {/* Main AppBar with shadow on scroll */}
      <AppToolbar />

      {/* Hero Section / Slider - Only on homepage */}
      {showSlider && (
        <Box
          sx={{
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: 100,
              background: `linear-gradient(to top, ${theme.palette.background.default}, transparent)`,
              pointerEvents: 'none',
              zIndex: 1,
            }
          }}
        >
          <Slider />
        </Box>
      )}

      {/* Main Content Area */}
      {isSupportPage ? (
        // Support pages - no extra container padding (SupportLayout has its own)
        <PageTransition>
          <Outlet />
        </PageTransition>
      ) : (
        // Regular pages - with container padding
        <Container
          maxWidth="lg"
          sx={{
            flex: 1,
            mt: showSlider ? 0 : 4,
            mb: 4,
            position: 'relative',
            zIndex: 1,
          }}
        >
          <PageTransition>
            <Outlet />
          </PageTransition>
        </Container>
      )}

      {/* Footer */}
      <Footer />

      {/* Scroll to Top Button */}
      <ScrollToTop />
    </Box>
  );
};

export default AppLayout;